/**
 * Shared validation constants for MCP tools.
 *
 * Centralises the phase-name and question-ID patterns that were previously
 * duplicated across questions.ts, pipeline.ts, and orchestration.ts.
 */

/** Phase names: lowercase alphanumeric + hyphens, 1–31 chars. */
export const SAFE_PHASE = /^[a-z][a-z0-9-]{0,30}$/;

/** Question IDs: alphanumeric (case-insensitive) + hyphens, 1–64 chars. */
export const SAFE_QUESTION_ID = /^[a-z0-9][a-z0-9-]{0,63}$/i;

/**
 * Artifact name slugs: lowercase alphanumeric + hyphens, 1–80 chars.
 * No path separators, spaces, or uppercase. Used to derive per-invocation
 * artifact filenames (e.g. api-config-<integrationName>.json,
 * workflow-config-<workflowName>.json). swp-x8sm.
 */
export const SAFE_SLUG = /^[a-z0-9][a-z0-9-]{0,79}$/;

export function isValidSlug(slug: string): boolean {
  return SAFE_SLUG.test(slug);
}

export function isValidPhase(phase: string): boolean {
  return SAFE_PHASE.test(phase);
}

export function isValidQuestionId(id: string): boolean {
  return SAFE_QUESTION_ID.test(id);
}
